import axios from "axios";
import {getField, updateField} from "vuex-map-fields";
import i18n from '@/i18n';

export default {
  namespaced: true,
  state: {
    fetched: false,
    isFetchedPrepayedTarrifplans: false,
    tarrifplans:[],
    prepayedTarrifplans:[],
  },
  getters: {
    getField, //vuex-map-fields
  },
  mutations: {
    updateField, //vuex-map-fields
  },
  actions: {
    getPrepayedTarrifplans({ commit, state, dispatch }){
      //prepayed-tarrifplans
      updateField(state, {path:'isFetchedPrepayedTarrifplans', value:true});
      axios.get(this._vm.$apiURL + '/prepayed-tarrifplans')
          .then((response) => {
            updateField(state, {path:'prepayedTarrifplans', value:response.data});
          })
          .catch((error) => {
            dispatch('common/showError', {'error': error}, {root:true});
          })
    },
    get({ commit, state, dispatch }){
      updateField(state, {path:'fetched', value:true});
      axios.get(this._vm.$apiURL + '/tarrifplans')
        .then((response) => {
          updateField(state, {path:'tarrifplans', value:response.data});
        })
        .catch((error) => {
          dispatch('common/showError', {'error': error}, {root:true});
        })
    },
    pay({ commit, state, dispatch }, payload){
      updateField(state, {path:'fetched', value:true});
      axios.post(this._vm.$apiURL + '/payment-init', payload)
        .then((response) => {
          if(response && response.data && response.data.success){
            window.open(response.data.url, '_blank');
          } else {
              throw this._vm.i18n.t('viewSettings.tarrifplans.payment_processing_error')
          }
        })
        .catch((error) => {
          dispatch('common/showError', {'error': error}, {root:true});
        })
    },
    async activateDemoTarrif({ commit, state, dispatch }){
      updateField(state, {path:'fetched', value:false});
      return await  axios.patch(this._vm.$apiURL + '/tarrifplans/activate-demo-tarrif')
          .then((response) => {
            if(response.data.status === "success") return true;
          })
          .catch((error) => {
            dispatch('common/showError', {'error': error}, {root:true});
            return false
          })
          .finally(()=>{
            updateField(state, {path:'fetched', value:true});
          })
    }
  }
}
